import {PlayWithOpponentAction} from "@dp-instant/gameflow";
import {SOCIAL_POPUP, IUser} from "@dp-instant/social";
import {TypesGame} from "@game/TypesGame";
import {inject} from "inversify";
import {GameModel} from "@game/coregame/model/GameModel";

export class PlayWithOpponentActionSIO extends PlayWithOpponentAction {
    @inject(TypesGame.model)
    protected model: GameModel;

    async execute(idOrOpponent?: IUser | undefined): Promise<any> {
        const status = await this.social.playWith(idOrOpponent, false);
        if (status === SOCIAL_POPUP.ACCEPTED) {
            await this.levelStart.run();
            this.model.startStage();
        }
    }
}
